module.exports = __webpack_public_path__ + "static/img/ic_bottom_community_off@2x.b73be9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_bottom_community_off@2x.png
// module id = OXpr
// module chunks = 1